import React, { FC } from 'react';

import { Text } from '@/components/typographies';
import { COLORS } from '@/styles/colors';

import Modal, { ModalProps } from '../Modal';
import * as styles from './styles';

export type WithButtonProps = {
  title: string;
  contentComponent: React.ReactNode;
  leftButton?: React.ReactNode;
  rightButton: React.ReactNode;
} & Omit<ModalProps, 'footerComponent'>;

const WithButton: FC<WithButtonProps> = (props) => {
  const { title, contentComponent, leftButton, rightButton, ...restProps } = props;

  return (
    <Modal
      contentComponent={
        <div className={styles.container}>
          <Text type={'heading5_700'} color={COLORS.GRAY_90}>
            {title}
          </Text>
          {contentComponent}
        </div>
      }
      footerComponent={
        <div className={styles.buttonContainer}>
          {leftButton}
          {rightButton}
        </div>
      }
      {...restProps}
    />
  );
};

export default WithButton;
